{
  "localize": {
    "hours": {
      "short": "{hours}u"
    },
    "hoursAndMinutes": {
      "short": "{hours}u{minutes}m"
    }
  },
  "widget": {
    "titles": {
      "sent-us-request": "Offerte aanvragen",
      "amazing": "Fantastisch!!",
      "ourPackages": "Onze arrangementen",
      "ask-name": "Wat is je voornaam?",
      "event-type-title": "Welk event wil je organiseren?",
      "event-type-subtitle": "Welk event wil je organiseren?",
      "survey-organizer-title": "Wat voor organisator ben jij?",
      "survey-organizer-subtitle": "Selecteer wat het beste bij je past.",
      "survey-theme-title": "En aan welke sfeer denk je voor je event?",
      "survey-theme-subtitle": "Selecteer één van deze thema's",
      "survey-appointment-title": "Is je datum flexibel?",
      "survey-appointment-subtitle": "Selecteer jouw voorkeur",
      "dank": "Hartelijk dank!!",
      "requested": "Aangevraagd!",
      "greetings-title": "Aangenaam {name}!"
    },
    "global": {
      "from": "Vanaf",
      "guest": "pp",
      "made-constell": "Event management software door CONSTELL",
      "loading": "Laden...",
      "error-wrong": "Er ging iets mis",
      "guests": "gasten",
      "no-products": "Geen producten",
      "per-people": "p.p",
      "read-more": "Lees meer",
      "read-less": "Lees minder",
      "people": "p.",
      "catalog": "Bekijk onze catalogus",
      "pricing-strategy": {
        "FLAT_FEE": "vaste prijs",
        "PER_GUESTTYPE": "per gast-type",
        "PER_HOUR": "per uur",
        "PER_MINUTE": "per minuut",
        "PER_PIECE": "per stuk"
      },
      "labels": {
        "capacity": "Capaciteit",
        "general": "Algemeen",
        "timeslot": "Gelegenheid"
      }
    },
    "package-list": {
      "no-results": "Geen arrangementen gevonden",
      "self-title": "Zelf offerte maken",
      "self-content": "Zelf een event samenstellen"
    },
    "package": {
      "included": "Inbegrepen",
      "generic-timeslot": "Algemeen",
      "all-day": "Hele dag",
      "program": "Programma",
      "program-day": "Programma dag {day}"
    },
    "buttons": {
      "plan-event": "Plan je event",
      "close": "Sluiten",
      "book-it": "Aanvragen",
      "send-request": "Versturen",
      "back-main": "Terug naar overzicht",
      "continue": "Verder",
      "next": "Volgende",
      "send": "Verstuur",
      "appointment": "Maak Afspraak",
      "skip": "Overslaan",
      "start": "Start offerte",
      "login": "Inloggen",
      "chatbox": "Stel je vraag..."
    },
    "messages": {
      "sent-us-request": "Wij sturen de door jou geselecteerde offerte zo snel mogelijk toe.",
      "request-success": "Je offerte aanvraag is ontvangen.",
      "request-success-2": "Wij gaan nu je offerte bereiden en nemen zo snel mogelijk contact met je op.",
      "request-success-3": "Let op! Dit is een afspraak-aanvraag. We nemen contact met je op om te bevestigen. We kijken er naar uit om je snel te ontmoeten en je event in detail te bespreken!",
      "request-success-4": "Wij gaan nu je offerte bereiden op basis van jouw wensen. We nemen snel contact met je op om te bespreken!",
      "errors": {
        "list-failed": "Er ging iets mis bij het ophalen van de arrangementen.",
        "request-failed": "Er ging iets mis bij het versturen van je verzoek."
      },
      "chatbox": "Chat direct met mij voor beschikbaarheid, arrangementen, prijzen, dieetwensen en elke andere vraag!"
    },
    "navigation": {
      "back": "Terug",
      "appointment": "Afspraak",
      "contact": "Contact",
      "call": "Bel ons"
    },
    "form": {
      "title": "Contactformulier",
      "subtitle": "We helpen je graag verder met je evenement. Vul dit formulier in en we nemen contact met je op.",
      "all-events": "Alle events",
      "choose-event": "Kies je event",
      "event-type": "Event type",
      "event-date": "Gewenste datum",
      "guest-amount": "Aantal gasten",
      "your-name": "Naam",
      "your-surname": "Achternaam",
      "email": "Jouw e-mail",
      "email-2": "E-mailadres",
      "company-name": "Bedrijfsnaam",
      "phone-number": "Telefoonnummer",
      "name": "Naam",
      "partner-name": "Naam partner",
      "partner-surname": "Achternaam partner",
      "other": "Wat voor een evenement is het?",
      "description": "Moet ik nog iets weten?",
      "description-2": "Omschrijf jouw event en wensen",
      "morning": "Ochtend",
      "afternoon": "Middag",
      "evening": "Avond",
      "whole-day": "Hele dag",
      "whole-evening": "Hele dag + avond",
      "multiday": " Meerdaags event",
      "only": "Alleen deze datum",
      "around": "Rond die periode",
      "negotiable": "Alles is nog bespreekbaar",
      "split": "Vertel ons meer over je evenement",
      "validations": {
        "required": "{field} is verplicht",
        "min": "{field} moet minimaal 1 zijn"
      },
      "appointment-title": "Afspraak aanvragen",
      "appointment-desc": "Let op! Wij nemen eerst nog contact op om te bevestigen.",
      "password": "Wachtwoord",
      "forgot-password": "Wachtwoord vergeten?",
      "phone": "Telefoonnummer"
    },
    "welcome": {
      "hello": "Hallo!",
      "by": "Welkom bij",
      "desc": "Maak, zoek & boek hier jouw",
      "start": "Start offerte aanvraag",
      "see": "Zie arrangementen",
      "menu": {
        "quote": "Offerte maken",
        "package": "Arrangementen",
        "contact": "Contact formulier",
        "appointment": "Afspraak maken"
      }
    },
    "selection": {
      "quick": "Arrangementen",
      "quick-desc": "Bekijk onze arrangementen en kant-en-klare events",
      "quick-action": "Direct aanvragen",
      "journey": "Vervolg je reis",
      "journey-desc": "Jouw offerte & event op maat met mijn advies en hulp",
      "journey-desc-2": "Samen je wensen bespreken",
      "journey-action": "Samen verder",
      "packages": "Arrangementen",
      "packages-desc": "Kant-en-klare events boeken",
      "quote": "Zelf offerte maken",
      "quote-desc": "Kies je programma, snacks, zalen en diner.",
      "quote-path": "Offerte maken",
      "quote-path-desc": "Stel je eigen programma samen en kies zelf zalen, hapjes, drankjes!",
      "quote-path-action": "Zelf maken"
    },
    "survey-organizer": {
      "pete-precise": "Pietje-precies",
      "perfectionist": "Praktisch",
      "delightfully-flexible": "Lekker flexibel",
      "practical": "Chaoot / YOLO"
    },
    "survey-theme": {
      "intieme-gezellig": "Intiem & gezellig",
      "chic-formeel": "Chic & Formeel",
      "feest-dansen": "Feest & Dansen",
      "informeel-gezellig": "Informeel & gezellig"
    },
    "survey-appointment": {
      "date-only": "Alleen",
      "date-some-1": "Een",
      "date-some-2": "in",
      "around-period": "Rond die periode",
      "negotiable": "Alles is bespreekbaar"
    },
    "date": {
      "when": "Wanneer is de grote dag?",
      "available": "(afhankelijk van beschikbaarheid)"
    },
    "amount": {
      "great": "Leuk {name}. Ik weet al wat meer!",
      "now": "Laten we het nu over je gasten hebben...",
      "how-many": "Hoeveel gasten verwacht je op jouw {event}?"
    },
    "descriptions": {
      "title": "Hoe zou je ze omschrijven?",
      "subtitle": "Selecteer verschillende opties",
      "eaters": "Grote eters",
      "small": "Kleine magen",
      "improv": "Koning van impro",
      "party": "Feestbeesten",
      "diet": "Speciaal dieet",
      "vegetarian": "Vegetarisch",
      "vegan": "Veganistisch",
      "sporty": "Sportief",
      "old": "Senior",
      "adult": "Volwassen",
      "kid": "Kinderen",
      "pregnant": "Zwanger",
      "handicap": "Minder valide",
      "dutch": "Nederlands",
      "english": "Internationale gasten",
      "alcohol": "Alcoholvrij",
      "gourmand": "Lekkerbekken",
      "drinkers": "Borrelaars"
    },
    "budget": {
      "title": "Wat is je budget?"
    },
    "host": {
      "title-1": "Ik ben {name},",
      "text-1": "jouw eventmanager, waarmee kan ik je helpen?",
      "title-2": "Leuk je te leren kennen!",
      "title-2-5": "Wat leuk! Gefeliciteerd!",
      "title-3": "Hoe wil je verder?",
      "title-4": "Fantastisch!",
      "title-5": "Dat is nog {days} dag te gaan",
      "title-6": "Dat is nog {days} dagen te gaan",
      "title-6-5": "Ik ga kijken wat ik kan doen",
      "title-7": "Om je te leren kennen!",
      "title-8": "Goed om te weten!",
      "title-9": "Wat een goede keuze!",
      "title-10": "Geef hier vast een afspraak-suggestie aan",
      "confirmation": "Ik zal zo snel mogelijk antwoorden!"
    },
    "appointment": {
      "title": "Wil je alvast een afspraak maken?",
      "subtitle": "om de offerte te bespreken",
      "yes": "Ja",
      "no": "Nee",
      "desc": "Stel een datum voor om jouw wensen met ons te bespreken.",
      "host": "Ik laat je snel weten of ik beschikbaar ben!"
    },
    "chat": {
      "customWelcomeMessage": "Heb je een vraag over beschikbaarheid, prijzen, dieetwensen of wil je een offerte maken? Ik kan je direct helpen!"
    },
    "loading": {
      "title": "Geweldig!!",
      "subtitle": "Alles is ingevuld en de resultaten worden gemaakt.",
      "offerte-title": "Goed Bezig!!",
      "offerte-subtitle": "Een voeg toe aan jouw offerte.",
      "quote-subtitle": "Je {event} komt al tot leven"
    },
    "summary": {
      "title": "{name}, je hebt geselecteerd",
      "desc": "We hebben jouw perfecte {event} samengesteld…"
    },
    "results": {
      "title": "Jouw resultaat",
      "subtitle": "Gefeliciteerd, een uniek event voor jou!",
      "packages": "{number} arrangementen!",
      "disc": "Misschien vind je deze arrangementen wel leuk",
      "options": {
        "intimate": "Intiem",
        "big": "Groot",
        "festive": "Feestelijk",
        "elegant": "Elegant",
        "simple": "Simpel",
        "unique": "Uniek",
        "international": "Internationaal",
        "dutch": "Nederlands",
        "talk": "Praten",
        "dance": "Dansen"
      },
      "form": {
        "title": "Maak je droom nu waar",
        "desc": "Stuur je antwoorden naar ons toe en ontvang een unieke offerte.",
        "name": "Naam",
        "company": "Bedrijfsnaam",
        "email": "Je e-mail",
        "description": "Moet ik nog iets weten?"
      }
    },
    "call-us": {
      "phone": "Telefoonnummer",
      "email": "E-mail",
      "address": "Bezoek ons"
    },
    "tutorial": {
      "skip": "Uitleg overslaan",
      "step-1": {
        "title": " Bepaal jouw wensen",
        "desc": "Selecteer hapjes, drankjes, diner en meer. En stel een voorlopige offerte samen.",
        "button": "Volgende"
      },
      "step-2": {
        "title": " Offerte aanpassen",
        "desc": "Pas de offerte aan op jouw budget. Zodat jij precies weet wat jouw event zal kosten.",
        "button": "Volgende"
      },
      "step-3": {
        "title": " Verstuur!",
        "desc": "Helemaal blij? Dan gaan we samen jouw event verder bespreken.",
        "button": "Beginnen!!"
      }
    },
    "quote": {
      "event-selection": {
        "back": "Uitleg"
      },
      "guest-selection": {
        "back": "Event type",
        "title": "Wie nodig je uit?"
      },
      "timeframes": {
        "back": "Gasten",
        "title": "Wanneer is jouw evenement?",
        "morning": "Ochtend",
        "afternoon": "Middag",
        "evening": "Avond",
        "whole-day": "Hele dag",
        "multiday": "Meerdaags"
      },
      "date": {
        "back": "Moment van de dag"
      },
      "survey": {
        "back": "Datum",
        "title": "Is je datum flexibel?",
        "subtitle": "Selecteer jouw voorkeur"
      },
      "template": {
        "back": "Datum voorkeur",
        "title": "Kies een programma",
        "subtitle": "Je kan straks nog tijden aanpassen of onderdelen toevoegen"
      },
      "amount": {
        "back": "Programma"
      },
      "program": {
        "back": "Aantal gasten"
      },
      "decoration": {
        "back": "Aantallen",
        "title": "Welke stijl of sfeer spreekt je aan?"
      },
      "entertainment": {
        "back": "Stijl",
        "title": "Welke activiteit of entertainment spreekt je aan?"
      },
      "space": {
        "back": "Activiteit",
        "title": "Onze zalen",
        "subtitle": "Kies één of meerdere zalen voor je {event}",
        "continue": "Overslaan",
        "confirm": "Selectie bevestigen"
      },
      "category": {
        "title": "Bekijk ons assortiment",
        "subtitle": "En voeg toe aan jouw offerte!",
        "skip": "Bekijk offerte"
      },
      "form": {
        "back": "Terug naar assortiment",
        "title": "Offerte aanvragen",
        "subtitle": "Ontvang een gedetailleerd kostenoverzicht op basis van jouw geselecteerde wensen."
      }
    },
    "register": {
      "title": "Start jouw offerte",
      "subtitle": "Waar wil jij een offerte voor maken?",
      "choose": "Kies een event",
      "event-types": {
        "wedding": "Bruiloft",
        "birthday": "Verjaardag",
        "baby-shower": "Babyshower",
        "company": "Bedrijfsfeest",
        "meeting": "Vergadering",
        "condolence": "Condoleance",
        "other": "Overig"
      }
    },
    "login": {
      "title": "Inloggen",
      "subtitle": "Welkom terug!"
    },
    "date-time": {
      "title": "Kies een datum, tijd en aantal gasten voor je {event}",
      "times": "Timeframe",
      "guest-amount": "Aantal gasten",
      "continue": "Verder",
      "start-time": "Begintijd",
      "end-time": "Eindtijd"
    },
    "shop": {
      "title": "Voeg per categorie producten toe aan je {event}",
      "all": "Alles"
    },
    "filter": {
      "date": "Datum",
      "time": "Tijd",
      "guests": "Gasten",
      "amount-guest": "{amount} gasten"
    }
  },
  "countries": {
    "AD": "Andorra",
    "AE": "Verenigde Arabische Emiraten",
    "AF": "Afghanistan",
    "AG": "Antigua en Barbuda",
    "AI": "Anguilla",
    "AL": "Albanië",
    "AM": "Armenië",
    "AO": "Angola",
    "AQ": "Antarctica",
    "AR": "Argentinië",
    "AS": "Amerikaans-Samoa",
    "AT": "Oostenrijk",
    "AU": "Australië",
    "AW": "Aruba",
    "AX": "Åland",
    "AZ": "Azerbeidzjan",
    "BA": "Bosnië en Herzegovina",
    "BB": "Barbados",
    "BD": "Bangladesh",
    "BE": "België",
    "BF": "Burkina Faso",
    "BG": "Bulgarije",
    "BH": "Bahrein",
    "BI": "Burundi",
    "BJ": "Benin",
    "BL": "Saint-Barthélemy",
    "BM": "Bermuda",
    "BN": "Brunei",
    "BO": "Bolivia",
    "BQ": "Bonaire, Sint Eustatius en Saba",
    "BR": "Brazilië",
    "BS": "Bahama's",
    "BT": "Bhutan",
    "BV": "Bouvet",
    "BW": "Botswana",
    "BY": "Wit-Rusland",
    "BZ": "Belize",
    "CA": "Canada",
    "CC": "Cocoseilanden",
    "CD": "Democratische republiek Congo",
    "CF": "Centraal-Afrikaanse Republiek",
    "CG": "Congo",
    "CH": "Zwitserland",
    "CI": "Ivoorkust",
    "CK": "Cookeilanden",
    "CL": "Chili",
    "CM": "Kameroen",
    "CN": "China",
    "CO": "Colombia",
    "CR": "Costa Rica",
    "CU": "Cuba",
    "CV": "Kaapverdië",
    "CW": "Curaçao",
    "CX": "Christmaseiland",
    "CY": "Cyprus",
    "CZ": "Tsjechië",
    "DE": "Duitsland",
    "DJ": "Djibouti",
    "DK": "Denemarken",
    "DM": "Dominica",
    "DO": "Dominicaanse Republiek",
    "DZ": "Algerije",
    "EC": "Ecuador",
    "EE": "Estland",
    "EG": "Egypte",
    "EH": "Westelijke Sahara",
    "ER": "Eritrea",
    "ES": "Spanje",
    "ET": "Ethiopië",
    "FI": "Finland",
    "FJ": "Fiji",
    "FK": "Falklandeilanden",
    "FM": "Micronesië",
    "FO": "Faeröer",
    "FR": "Frankrijk",
    "GA": "Gabon",
    "GB": "Verenigd Koninkrijk",
    "GD": "Grenada",
    "GE": "Georgië",
    "GF": "Frans-Guyana",
    "GG": "Guernsey",
    "GH": "Ghana",
    "GI": "Gibraltar",
    "GL": "Groenland",
    "GM": "Gambia",
    "GN": "Guinee",
    "GP": "Guadeloupe",
    "GQ": "Equatoriaal-Guinea",
    "GR": "Griekenland",
    "GS": "Zuid-Georgia en de Zuidelijke Sandwicheilanden",
    "GT": "Guatemala",
    "GU": "Guam",
    "GW": "Guinee-Bissau",
    "GY": "Guyana",
    "HK": "Hongkong",
    "HM": "Heard en McDonaldeilanden",
    "HN": "Honduras",
    "HR": "Kroatië",
    "HT": "Haïti",
    "HU": "Hongarije",
    "ID": "Indonesië",
    "IE": "Ierland",
    "IL": "Israël",
    "IM": "Man",
    "IN": "India",
    "IO": "Brits Indische Oceaanterritorium",
    "IQ": "Irak",
    "IR": "Iran",
    "IS": "IJsland",
    "IT": "Italië",
    "JE": "Jersey",
    "JM": "Jamaica",
    "JO": "Jordanië",
    "JP": "Japan",
    "KE": "Kenia",
    "KG": "Kirgizië",
    "KH": "Cambodja",
    "KI": "Kiribati",
    "KM": "Comoren",
    "KN": "Saint Kitts en Nevis",
    "KP": "Noord-Korea",
    "KR": "Zuid-Korea",
    "KW": "Koeweit",
    "KY": "Kaaimaneilanden",
    "KZ": "Kazachstan",
    "LA": "Laos",
    "LB": "Libanon",
    "LC": "Saint Lucia",
    "LI": "Liechtenstein",
    "LK": "Sri Lanka",
    "LR": "Liberia",
    "LS": "Lesotho",
    "LT": "Litouwen",
    "LU": "Luxemburg",
    "LV": "Letland",
    "LY": "Libië",
    "MA": "Marokko",
    "MC": "Monaco",
    "MD": "Moldavië",
    "ME": "Montenegro",
    "MF": "Sint Maarten (Frans deel)",
    "MG": "Madagaskar",
    "MH": "Marshalleilanden",
    "MK": "Noord-Macedonië",
    "ML": "Mali",
    "MM": "Myanmar",
    "MN": "Mongolië",
    "MO": "Macau",
    "MP": "Noordelijke Marianen",
    "MQ": "Martinique",
    "MR": "Mauritanië",
    "MS": "Montserrat",
    "MT": "Malta",
    "MU": "Mauritius",
    "MV": "Malediven",
    "MW": "Malawi",
    "MX": "Mexico",
    "MY": "Maleisië",
    "MZ": "Mozambique",
    "NA": "Namibië",
    "NC": "Nieuw-Caledonië",
    "NE": "Niger",
    "NF": "Norfolk",
    "NG": "Nigeria",
    "NI": "Nicaragua",
    "NL": "Nederland",
    "NO": "Noorwegen",
    "NP": "Nepal",
    "NR": "Nauru",
    "NU": "Niue",
    "NZ": "Nieuw-Zeeland",
    "OM": "Oman",
    "PA": "Panama",
    "PE": "Peru",
    "PF": "Frans-Polynesië",
    "PG": "Papoea-Nieuw-Guinea",
    "PH": "Filipijnen",
    "PK": "Pakistan",
    "PL": "Polen",
    "PM": "Saint-Pierre en Miquelon",
    "PN": "Pitcairn",
    "PR": "Puerto Rico",
    "PS": "Palestina",
    "PT": "Portugal",
    "PW": "Palau",
    "PY": "Paraguay",
    "QA": "Qatar",
    "RE": "Réunion",
    "RO": "Roemenië",
    "RS": "Servië",
    "RU": "Rusland",
    "RW": "Rwanda",
    "SA": "Saoedi-Arabië",
    "SB": "Salomonseilanden",
    "SC": "Seychellen",
    "SD": "Soedan",
    "SE": "Zweden",
    "SG": "Singapore",
    "SH": "Sint-Helena, Ascension en Tristan da Cunha",
    "SI": "Slovenië",
    "SJ": "Spitsbergen en Jan Mayen",
    "SK": "Slowakije",
    "SL": "Sierra Leone",
    "SM": "San Marino",
    "SN": "Senegal",
    "SO": "Somalië",
    "SR": "Suriname",
    "SS": "Zuid-Soedan",
    "ST": "Sao Tomé en Principe",
    "SV": "El Salvador",
    "SX": "Sint Maarten",
    "SY": "Syrië",
    "SZ": "Eswatini",
    "TC": "Turks- en Caicoseilanden",
    "TD": "Tsjaad",
    "TF": "Franse Zuidelijke Gebieden",
    "TG": "Togo",
    "TH": "Thailand",
    "TJ": "Tadzjikistan",
    "TK": "Tokelau",
    "TL": "Oost-Timor",
    "TM": "Turkmenistan",
    "TN": "Tunesië",
    "TO": "Tonga",
    "TR": "Turkije",
    "TT": "Trinidad en Tobago",
    "TV": "Tuvalu",
    "TW": "Taiwan",
    "TZ": "Tanzania",
    "UA": "Oekraïne",
    "UG": "Oeganda",
    "UM": "Amerikaanse Kleinere Afgelegen Eilanden",
    "US": "Verenigde Staten",
    "UY": "Uruguay",
    "UZ": "Oezbekistan",
    "VA": "Vaticaanstad",
    "VC": "Saint Vincent en de Grenadines",
    "VE": "Venezuela",
    "VG": "Britse Maagdeneilanden",
    "VI": "Amerikaanse Maagdeneilanden",
    "VN": "Vietnam",
    "VU": "Vanuatu",
    "WF": "Wallis en Futuna",
    "WS": "Samoa",
    "YE": "Jemen",
    "YT": "Mayotte",
    "ZA": "Zuid-Afrika",
    "ZM": "Zambia",
    "ZW": "Zimbabwe"
  }
}